import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { getToken } from '@/utils/token';
import { removeToken } from '@/utils/token';

const baseConfig: RequestConfig = {
  requestInterceptors: [
    (config: RequestOptions) => {
      const token = getToken();
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
      if (config.params) {
        config.params = Object.fromEntries(
          Object.entries(config.params).filter(([_, v]) => v !== null && v !== undefined)
        );
      }
      if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
        config.data = Object.fromEntries(
          Object.entries(config.data).filter(([_, v]) => v !== null && v !== undefined)
        );
      }
      return config;
    },
  ],

  responseInterceptors: [
    (response) => {
      return response;
    },
  ],

  errorConfig: {
    errorHandler: (error: any) => {
      const status = error.response?.status || error.status;
      if (status === 401) {
        removeToken();
        window.location.href = '/user/login';
      }
      if (error.response?.data?.message) {
        error.message = error.response.data.message;
      }
      return Promise.reject(error);
    },
  },
};

export const errorConfig = baseConfig;
